//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectCoordinateSystem.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AlignedType",1,0],[0,"AxisPoint",1,"Point",0],[0,"AxisVector",1,"Direction",0],[0,"BoundedObject",0,"ScCollector",0],[0,"BoxColor",1,0],[0,"BoxPosition",1,0],[1,"Clearance",0,"Expression",0],[0,"CsysAssociative",1,0],[1,"CsysSelection",0,"SelectCoordinateSystem",0],[1,"FacetBodies",0,"SelectNXObjectList",0],[0,"NeedReferenceExpression",1,0],[0,"NonAlignedMinimumBox",1,0],[1,"OffsetNegativeX",0,"Expression",0],[1,"OffsetNegativeY",0,"Expression",0],[1,"OffsetNegativeZ",0,"Expression",0],[1,"OffsetPositiveX",0,"Expression",0],[1,"OffsetPositiveY",0,"Expression",0],[1,"OffsetPositiveZ",0,"Expression",0],[0,"PositionPrecisionValue",1,0],[0,"PrecisionValue",1,0],[1,"RadialOffset",0,"Expression",0],[0,"ReferenceCsysType",1,0],[0,"ShowDimension",1,0],[0,"SingleOffset",1,0],[0,"Type",1,0],[1,"XValue",0,"Expression",0],[1,"YValue",0,"Expression",0],[1,"ZValue",0,"Expression",0]],[[["matrix","position"],"SetBoxMatrixAndPosition",{},2,0],[["numSelections","selectedObjects"],"GetSelectedOccurrences",{},0,0],[["selections","deselections"],"SetSelectedOccurrences",{},2,0],[[],"CalculateBoxSize",{},0,0],[["xLength","yLength","zLength","leftLowerPoint"],"AskBlockBoundingBoxSize",{},0,0],[["diameter","height","lowerCenterPoint"],"AskCylinderBoundingBoxSize",{},0,0],[["xLength","yLength","zLength","leftLowerPoint","matrix"],"AskNonAlignedMinimumBoxSize",{},0,0]],[]];
SPLM.Features.ToolingBoxBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ToolingBoxBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ToolingBoxBuilder.Types = Object.freeze({
    "CenterAndLengths" : "CenterAndLengths", "BoundedBlock" : "BoundedBlock", "BoundedCylinder" : "BoundedCylinder"});

SPLM.Features.ToolingBoxBuilder.RefCsysType = Object.freeze({
    "Wcs" : "Wcs", "AbsoluteinDisplayedPart" : "AbsoluteinDisplayedPart", "SelectedCsys" : "SelectedCsys"});

SPLM.Features.ToolingBoxBuilder.AlignedBlockType = Object.freeze({
    "Csys" : "Csys", "Vector" : "Vector", "NonAligned" : "NonAligned"});

export default SPLM;